module.exports = __webpack_public_path__ + "img/16_32.def39090.png";